module.exports = __webpack_public_path__ + "static/media/pharmacy.076c6d5d.svg";